import styled from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
import { TEXT_GREY_LIGHT } from '@CSSVars/colors'


export const _Container = styled.div`
  position: relative;
  input {
    width: 100%;
    padding: 15px;
  }
    .react-autosuggest__suggestions-container {
      position: absolute;
      width: calc(100% + 100px);
    }
    .react-autosuggest__suggestions-container--open {
      max-height: 250px;
      overflow-y: scroll;
      box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.14) !important;
    }
    .react-autosuggest__input::placeholder {
      color: ${TEXT_GREY_LIGHT};
    }
`

export const _CloseIcon = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  padding: 20px;
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  &:hover {
    cursor: pointer;
  }
  svg {
    fill: black;
  }
`
